import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px solid #737da8;
  padding: 14px;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
`;

export const IconContainer = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
`;

export const IconContainerSmall = styled.div`
  display: flex;
  gap: 3px;
  align-items: center;
  margin-bottom: 9px;
`;

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  margin-bottom: 4px;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const IconWrapperSmall = styled.div`
  width: 11px;
  height: 14px;
  margin-bottom: 4px;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const ImageWrapper = styled.div`
  width: 28px;
  height: 28px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MinusIcon = styled.div`
  width: 14px;
  border-radius: 1px;
  border: 1px solid #ffffff;
  background-color: #ffffff;
`;

export const OpenedDescriptionContainer = styled.div`
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const OpenedDescriptionHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  align-items: flex-start;
`;

export const OpenedDescriptionHeadingText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
`;

export const OpenedDescriptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const GridContainer = styled.div`
  display: grid;
  /* grid-template-columns: repeat(2, 1fr); */
  grid-template-columns: repeat(1fr);
  gap: 10px;
`;
